module.exports = __webpack_public_path__ + "suryasir-9365f212.webp";